import { computed, ref } from 'vue';

import type { MicroInverters } from "~/types/equipment"

type SortableColumn =
  | 'brand'
  | 'count_key'
  | 'is_enabled'
  | 'is_hybrid'
  | 'model'
  | 'overload'
  | 'phase_id'
  | 'power'
  | 'tension';
type SortDirection = 'asc' | 'desc';

interface SortState {
  column: null | SortableColumn;
  direction: SortDirection;
}

export default function useTableSorting(getMicroInverters: () => MicroInverters.MicroInverter[] | undefined) {
  const sortState = ref<SortState>({
    column: null,
    direction: 'asc',
  });

  const sortedMicroInverters = computed(() => {
    const microInverters = getMicroInverters();
    if (!microInverters || !sortState.value.column) return microInverters;

    const { column, direction } = sortState.value;

    return [...microInverters].sort((a, b) => {
      let aValue = a[column];
      let bValue = b[column];

      if (typeof aValue === 'string') aValue = aValue.toLowerCase();
      if (typeof bValue === 'string') bValue = bValue.toLowerCase();

      if (aValue < bValue) return direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  });

  function handleSort(column: SortableColumn): void {
    if (sortState.value.column === column) {
      sortState.value.direction = sortState.value.direction === 'asc' ? 'desc' : 'asc';
    } else {
      sortState.value.column = column;
      sortState.value.direction = 'asc';
    }
  }

  return {
    handleSort,
    sortedMicroInverters,
    sortState,
  };
}
